/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgotpasswordtitle2Inputs */

const zh_auth_forgotpasswordtitle2 = /** @type {(inputs: Auth_Forgotpasswordtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忘记密码？`)
};

const en_auth_forgotpasswordtitle2 = /** @type {(inputs: Auth_Forgotpasswordtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot your password?`)
};

const es_auth_forgotpasswordtitle2 = /** @type {(inputs: Auth_Forgotpasswordtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Olvidaste tu contraseña?`)
};

/**
* | output |
* | --- |
* | "Forgot your password?" |
*
* @param {Auth_Forgotpasswordtitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_forgotpasswordtitle2 = /** @type {((inputs?: Auth_Forgotpasswordtitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgotpasswordtitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_forgotpasswordtitle2(inputs)
	if (locale === "en") return en_auth_forgotpasswordtitle2(inputs)
	return es_auth_forgotpasswordtitle2(inputs)
});
export { auth_forgotpasswordtitle2 as "auth_forgotPasswordTitle" }